const colorsBase = {
  green: {
    primary: '#028996',
    secondary: '#6fb8bf',
    tertiary: '#A3E8EF',
    quaternary: '#9EF0BD',
    quinary: '',
    contrast: '#e9e9e9',
  },

  blue: {
    primary: '#01758e',
    secondary: '#4a6b7f',
    tertiary: '#89c3cf',
    quaternary: '#B4EEF3',
    quinary: '#5CBCE9',
    contrast: '#f6f6f6',
  },

  red: {
    primary: '#b2292e',
    secondary: '#e39195',
    tertiary: '#DC5570',
    quaternary: '#D16960',
    quinary: '',
    contrast: '#f6f6f6',
  },

  // Our legacy yellow
  darkerYellow: {
    primary: '#FFD667',
    secondary: '',
    tertiary: '#F8EAD3',
    quaternary: '',
    quinary: '',
    contrast: '',
  },

  yellow: {
    primary: '#fff456', // rgb(255, 244, 86)
    secondary: '',
    tertiary: '#fffad8', // rgb(255, 250, 216)
    quaternary: '',
    quinary: '',
    contrast: '',
  },

  orange: {
    primary: '#FF4713',
    secondary: '#ECD2B4',
    tertiary: '#fbab1f',
    quaternary: '#fbab1f',
    quinary: '',
    contrast: '#f6f6f6',
  },

  black: {
    primary: '#312329',
    secondary: '#000000',
    tertiary: '#10132E',
    quaternary: '',
    quinary: '',
    contrast: '#f6f6f6',
  },

  lightGrey: {
    primary: '#e9e9e9',
    secondary: '#f6f6f6',
    tertiary: '#b0b0b0',
    quaternary: '#c1d6e0',
    quinary: '',
    contrast: '#505050',
  },

  grey: {
    primary: '#a1a1a1',
    secondary: '#d8d8d8',
    tertiary: '#d9dedf',
    quaternary: '',
    quinary: '',
    contrast: '#505050',
  },

  darkGrey: {
    primary: '#505050',
    secondary: '#767676',
    tertiary: '',
    quaternary: '',
    quinary: '',
    contrast: '#f6f6f6',
  },

  white: {
    primary: '#ffffff',
    secondary: '#f6f6f6',
    tertiary: '#fefefe',
    quaternary: '',
    quinary: '',
    contrast: '#455eab',
  },

  transparent: {
    primary: 'transparent',
    secondary: '',
    tertiary: '',
    quaternary: '',
    quinary: '',
    contrast: '#312329',
  },

  bodyArmor: {
    primary: '#d1001b',
    secondary: '#b8d4e6',
    tertiary: '',
    quaternary: '',
    quinary: '',
    contrast: '',
  },

  lightGreen: {
    primary: '#36C681',
    secondary: '#9EF0BD',
    tertiary: '#D7ECEE',
    quaternary: '',
    quinary: '',
    contrast: '',
  },

  cyan: {
    primary: '#70b7be',
    secondary: '',
    tertiary: '#387f96',
    quaternary: '',
    quinary: '',
    contrast: '',
  },

  purple: {
    primary: '#8D8095',
    secondary: '#A79EAE',
    tertiary: '',
    quaternary: '',
    quinary: '',
    contrast: '',
  },

  sunnyYellow: {
    primary: '#fff456',
    secondary: '#fff78f',
    tertiary: '#fffad8',
    quaternary: '',
    quinary: '',
    contrast: '',
  },
  indigo: {
    primary: '#455eab', // rgb(69, 94, 171)
    secondary: '#80a0d3', // rgb(128, 160, 211)
    tertiary: '#a7c2e5', // rgb(167, 194, 229)
    quaternary: '#cbd8ee',
    quinary: '#8393CA',
    contrast: '#f6f6f6',
  },
  periwinkle: {
    primary: '#80a0d3',
    secondary: '#a7c2e5',
    tertiary: '#cbd8ee',
    quaternary: '',
    quinary: '',
    contrast: '',
  },
  juicyPeach: {
    primary: '#fbab1f',
    secondary: '',
    tertiary: '',
    quaternary: '',
    quinary: '',
    contrast: '',
  },
  strawberryLemonade: {
    primary: '#ff3063',
    secondary: '',
    tertiary: '',
    quaternary: '',
    quinary: '',
    contrast: '',
  },
};

// Here we can create semantic color roles. Eg: "brand".
const colors = {
  ...colorsBase,
  brand: {
    primary: colorsBase.indigo.primary,
    secondary: colorsBase.indigo.secondary,
    tertiary: colorsBase.indigo.tertiary,
    quaternary: colorsBase.indigo.quaternary,
    quinary: colorsBase.indigo.quinary,
    contrast: colorsBase.indigo.contrast,
  },
  // brand: {
  //   primary: colorsBase.blue.primary,
  //   secondary: colorsBase.blue.secondary,
  //   tertiary: colorsBase.blue.tertiary,
  //   quaternary: colorsBase.blue.quaternary,
  //   quinary: colorsBase.blue.quinary,
  //   contrast: colorsBase.blue.contrast,
  // },
};

type ColorNameTypes = keyof typeof colors;

type ColorLevelTypes = keyof typeof colors.green;

const colorNames = Object.keys(colors) as ColorNameTypes[];

const colorLevels = Object.keys(colors.green) as ColorLevelTypes[];

export { colors, colorNames, colorLevels };

export type { ColorLevelTypes, ColorNameTypes };
